// A full page load, as opposed to an in-app navigate(). Kept in its own module so tests can mock it: jsdom cannot
// navigate, and in the vmThreads test pool `window.location` cannot be replaced to capture the target either.
export function redirectTo(url: string) {
    window.location.href = url;
}
